// Mock client detail data for portfolio dashboard
export const CLIENT_DETAIL_DATA = {
  1: {
    totalValue: 8950000,
    dayChange: { value: 45000, percent: 0.51 },
    ytdReturn: 8.5,
    realizedGains: 125000,
    allocation: {
      usEquity: 45,
      intlEquity: 15,
      fixedIncome: 25,
      cash: 8,
      alternatives: 7,
    },
    holdings: [
      {
        id: 1,
        symbol: 'VTI',
        name: 'Vanguard Total Stock Market ETF',
        quantity: 5000,
        price: 230.50,
        value: 1152500,
        costBasis: 1050000,
        gainLoss: 102500,
        gainLossPercent: 9.76,
        allocation: 12.9,
        taxLots: [
          { date: '2022-01-15', quantity: 2000, costBasis: 420000, gainLoss: 41000 },
          { date: '2022-06-20', quantity: 3000, costBasis: 630000, gainLoss: 61500 },
        ],
      },
      {
        id: 2,
        symbol: 'AAPL',
        name: 'Apple Inc.',
        quantity: 3500,
        price: 185.20,
        value: 648200,
        costBasis: 580000,
        gainLoss: 68200,
        gainLossPercent: 11.76,
        allocation: 7.2,
        taxLots: [
          { date: '2021-03-10', quantity: 1500, costBasis: 255000, gainLoss: 22800 },
          { date: '2022-09-15', quantity: 2000, costBasis: 325000, gainLoss: 45400 },
        ],
      },
      {
        id: 3,
        symbol: 'MSFT',
        name: 'Microsoft Corporation',
        quantity: 1800,
        price: 380.75,
        value: 685350,
        costBasis: 615000,
        gainLoss: 70350,
        gainLossPercent: 11.44,
        allocation: 7.7,
        taxLots: [
          { date: '2021-11-05', quantity: 800, costBasis: 272000, gainLoss: 32600 },
          { date: '2022-04-20', quantity: 1000, costBasis: 343000, gainLoss: 37750 },
        ],
      },
      {
        id: 4,
        symbol: 'GOOGL',
        name: 'Alphabet Inc.',
        quantity: 2500,
        price: 142.50,
        value: 356250,
        costBasis: 320000,
        gainLoss: 36250,
        gainLossPercent: 11.33,
        allocation: 4.0,
        taxLots: [],
      },
      {
        id: 5,
        symbol: 'AMZN',
        name: 'Amazon.com Inc.',
        quantity: 2200,
        price: 148.30,
        value: 326260,
        costBasis: 298000,
        gainLoss: 28260,
        gainLossPercent: 9.48,
        allocation: 3.6,
        taxLots: [],
      },
      {
        id: 6,
        symbol: 'BRK.B',
        name: 'Berkshire Hathaway Inc.',
        quantity: 1200,
        price: 365.80,
        value: 438960,
        costBasis: 400000,
        gainLoss: 38960,
        gainLossPercent: 9.74,
        allocation: 4.9,
        taxLots: [],
      },
      {
        id: 7,
        symbol: 'VXUS',
        name: 'Vanguard Total International Stock ETF',
        quantity: 8000,
        price: 62.40,
        value: 499200,
        costBasis: 470000,
        gainLoss: 29200,
        gainLossPercent: 6.21,
        allocation: 5.6,
        taxLots: [],
      },
      {
        id: 8,
        symbol: 'IEMG',
        name: 'iShares Core MSCI Emerging Markets ETF',
        quantity: 10000,
        price: 51.20,
        value: 512000,
        costBasis: 485000,
        gainLoss: 27000,
        gainLossPercent: 5.57,
        allocation: 5.7,
        taxLots: [],
      },
      {
        id: 9,
        symbol: 'AGG',
        name: 'iShares Core US Aggregate Bond ETF',
        quantity: 12000,
        price: 98.50,
        value: 1182000,
        costBasis: 1150000,
        gainLoss: 32000,
        gainLossPercent: 2.78,
        allocation: 13.2,
        taxLots: [],
      },
      {
        id: 10,
        symbol: 'TIP',
        name: 'iShares TIPS Bond ETF',
        quantity: 5000,
        price: 109.20,
        value: 546000,
        costBasis: 530000,
        gainLoss: 16000,
        gainLossPercent: 3.02,
        allocation: 6.1,
        taxLots: [],
      },
      {
        id: 11,
        symbol: 'LQD',
        name: 'iShares iBoxx $ Investment Grade Corporate Bond ETF',
        quantity: 4500,
        price: 108.90,
        value: 490050,
        costBasis: 475000,
        gainLoss: 15050,
        gainLossPercent: 3.17,
        allocation: 5.5,
        taxLots: [],
      },
      {
        id: 12,
        symbol: 'VNQ',
        name: 'Vanguard Real Estate ETF',
        quantity: 3000,
        price: 82.40,
        value: 247200,
        costBasis: 235000,
        gainLoss: 12200,
        gainLossPercent: 5.19,
        allocation: 2.8,
        taxLots: [],
      },
      {
        id: 13,
        symbol: 'GLD',
        name: 'SPDR Gold Shares',
        quantity: 2000,
        price: 185.60,
        value: 371200,
        costBasis: 360000,
        gainLoss: 11200,
        gainLossPercent: 3.11,
        allocation: 4.1,
        taxLots: [],
      },
      {
        id: 14,
        symbol: 'SHY',
        name: 'iShares 1-3 Year Treasury Bond ETF',
        quantity: 10000,
        price: 81.30,
        value: 813000,
        costBasis: 805000,
        gainLoss: 8000,
        gainLossPercent: 0.99,
        allocation: 9.1,
        taxLots: [],
      },
      {
        id: 15,
        symbol: 'JPM',
        name: 'JPMorgan Chase & Co.',
        quantity: 1500,
        price: 152.40,
        value: 228600,
        costBasis: 215000,
        gainLoss: 13600,
        gainLossPercent: 6.33,
        allocation: 2.6,
        taxLots: [],
      },
      {
        id: 16,
        symbol: 'JNJ',
        name: 'Johnson & Johnson',
        quantity: 2000,
        price: 158.90,
        value: 317800,
        costBasis: 305000,
        gainLoss: 12800,
        gainLossPercent: 4.20,
        allocation: 3.6,
        taxLots: [],
      },
      {
        id: 17,
        symbol: 'PG',
        name: 'Procter & Gamble Co.',
        quantity: 1800,
        price: 152.30,
        value: 274140,
        costBasis: 265000,
        gainLoss: 9140,
        gainLossPercent: 3.45,
        allocation: 3.1,
        taxLots: [],
      },
      {
        id: 18,
        symbol: 'DIS',
        name: 'Walt Disney Company',
        quantity: 2500,
        price: 95.20,
        value: 238000,
        costBasis: 230000,
        gainLoss: 8000,
        gainLossPercent: 3.48,
        allocation: 2.7,
        taxLots: [],
      },
      {
        id: 19,
        symbol: 'CASH',
        name: 'Cash & Money Market',
        quantity: 1,
        price: 716000,
        value: 716000,
        costBasis: 716000,
        gainLoss: 0,
        gainLossPercent: 0,
        allocation: 8.0,
        taxLots: [],
      },
    ],
    benchmarkData: {
      '1D': [
        { date: 'Start', portfolio: 100, sp500: 100, bond: 100 },
        { date: 'End', portfolio: 100.51, sp500: 100.35, bond: 100.02 },
      ],
      '1W': [
        { date: 'W-5', portfolio: 100, sp500: 100, bond: 100 },
        { date: 'W-4', portfolio: 101.2, sp500: 100.8, bond: 100.1 },
        { date: 'W-3', portfolio: 100.8, sp500: 101.1, bond: 100.15 },
        { date: 'W-2', portfolio: 102.1, sp500: 101.5, bond: 100.2 },
        { date: 'W-1', portfolio: 101.8, sp500: 101.3, bond: 100.25 },
        { date: 'Today', portfolio: 102.5, sp500: 101.8, bond: 100.3 },
      ],
      '1M': [
        { date: 'W1', portfolio: 100, sp500: 100, bond: 100 },
        { date: 'W2', portfolio: 102.3, sp500: 101.2, bond: 100.4 },
        { date: 'W3', portfolio: 101.8, sp500: 100.9, bond: 100.5 },
        { date: 'W4', portfolio: 103.5, sp500: 102.1, bond: 100.7 },
      ],
      'YTD': [
        { date: 'Jan', portfolio: 100, sp500: 100, bond: 100 },
        { date: 'Feb', portfolio: 102.1, sp500: 101.3, bond: 99.8 },
        { date: 'Mar', portfolio: 101.5, sp500: 100.8, bond: 99.5 },
        { date: 'Apr', portfolio: 103.2, sp500: 102.5, bond: 99.7 },
        { date: 'May', portfolio: 104.8, sp500: 103.2, bond: 100.1 },
        { date: 'Jun', portfolio: 105.5, sp500: 104.1, bond: 100.3 },
        { date: 'Jul', portfolio: 106.8, sp500: 105.2, bond: 100.5 },
        { date: 'Aug', portfolio: 107.2, sp500: 105.8, bond: 100.6 },
        { date: 'Sep', portfolio: 108.5, sp500: 107.1, bond: 100.8 },
      ],
      '1Y': [
        { date: "Jan '21", portfolio: 650000, benchmark: 645000 },
        { date: "Mar '21", portfolio: 680000, benchmark: 660000 },
        { date: "May '21", portfolio: 720000, benchmark: 690000 },
        { date: "Jul '21", portfolio: 750000, benchmark: 710000 },
        { date: "Sep '21", portfolio: 790000, benchmark: 740000 },
        { date: "Nov '21", portfolio: 830000, benchmark: 780000 },
        { date: "Jan '22", portfolio: 865000, benchmark: 810000 },
        { date: "Mar '22", portfolio: 910000, benchmark: 850000 },
        { date: "May '22", portfolio: 950000, benchmark: 880000 },
        { date: "Jul '22", portfolio: 1020000, benchmark: 930000 },
        { date: "Sep '22", portfolio: 1080000, benchmark: 970000 },
        { date: "Nov '22", portfolio: 1150000, benchmark: 1020000 },
        { date: "Jan '23", portfolio: 1240000, benchmark: 1080000 },
        { date: "Mar '23", portfolio: 1350000, benchmark: 1150000 },
        { date: "May '23", portfolio: 1480000, benchmark: 1230000 },
        { date: "Jul '23", portfolio: 1620000, benchmark: 1320000 },
        { date: "Sep '23", portfolio: 1780000, benchmark: 1420000 },
        { date: "Nov '23", portfolio: 1950000, benchmark: 1540000 },
        { date: "Jan '24", portfolio: 2150000, benchmark: 1680000 },
        { date: "Mar '24", portfolio: 2350000, benchmark: 1840000 },
        { date: "May '24", portfolio: 2580000, benchmark: 2010000 },
      ],
    },
  },
  2: {
    totalValue: 5250000,
    dayChange: { value: 28000, percent: 0.54 },
    ytdReturn: 7.2,
    realizedGains: 85000,
    allocation: {
      usEquity: 55,
      intlEquity: 10,
      fixedIncome: 20,
      cash: 10,
      alternatives: 5,
    },
    holdings: [],
    benchmarkData: {},
  },
  3: {
    totalValue: 12500000,
    dayChange: { value: -35000, percent: -0.28 },
    ytdReturn: 9.1,
    realizedGains: 195000,
    allocation: {
      usEquity: 40,
      intlEquity: 20,
      fixedIncome: 30,
      cash: 5,
      alternatives: 5,
    },
    holdings: [],
    benchmarkData: {},
  },
  4: {
    totalValue: 3800000,
    dayChange: { value: 15000, percent: 0.40 },
    ytdReturn: 6.8,
    realizedGains: 55000,
    allocation: {
      usEquity: 50,
      intlEquity: 15,
      fixedIncome: 25,
      cash: 7,
      alternatives: 3,
    },
    holdings: [],
    benchmarkData: {},
  },
  5: {
    totalValue: 7200000,
    dayChange: { value: 42000, percent: 0.59 },
    ytdReturn: 10.2,
    realizedGains: 142000,
    allocation: {
      usEquity: 60,
      intlEquity: 15,
      fixedIncome: 15,
      cash: 5,
      alternatives: 5,
    },
    holdings: [],
    benchmarkData: {},
  },
};

// Shared client data for overview
export const CLIENT_DATA = {
  1: { name: "Acme Corporation", lastModified: "2024-07-29" },
  2: { name: "TechStart Inc.", lastModified: "2024-07-28" },
  3: { name: "Global Industries", lastModified: "2024-07-27" },
  4: { name: "Innovation Labs", lastModified: "2024-07-26" },
  5: { name: "Future Systems", lastModified: "2024-07-25" },
};

// Helper function to get client data
export const getClientData = (clientId) => {
  return CLIENT_DATA[clientId] || {
    name: `Client ${clientId}`,
    lastModified: "Unknown",
  };
};

// Helper function to get all clients for overview
export const getAllClients = () => {
  return Object.entries(CLIENT_DATA).map(([id, data]) => ({
    id: parseInt(id),
    name: data.name,
    lastModified: data.lastModified,
  }));
};

